"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Svg = __importStar(require("react-native-svg"));
exports.default = (props) => (React.createElement(Svg.Svg, Object.assign({}, props, { viewBox: '0 0 24 24' }),
    React.createElement(Svg.G, { id: 'Layer_2', "data-name": 'Layer 2' },
        React.createElement(Svg.G, { id: 'smiling-face' },
            React.createElement(Svg.G, { id: 'smiling-face', "data-name": 'smiling-face' },
                React.createElement(Svg.Rect, { width: '24', height: '24', opacity: '0' }),
                React.createElement(Svg.Path, { d: 'M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm5 9a5 5 0 0 1-10 0z', id: '\uD83C\uDFA8-Icon-\u0421olor' }))))));
//# sourceMappingURL=SmilingFaceOutline.js.map